<table [formGroup]="parentFormGroup" class="indicator-table">
  <thead>
    <tr>
      <th class="text-center"></th>
      <th class="title">Indicador</th>
      <th class="text-center">Cód.</th>
      <th class="text-center">Polar.</th>
      <th class="text-center">Medida</th>
      <th class="text-center">Meta</th>
      <th class="text-center">Realizado</th>
      <th class="text-center">Apuração</th>
      <th class="text-center">Status</th>
      <th class="text-center">Projeção</th>
      <th class="text-center">PC</th>
      <th class="text-center"></th>
    </tr>
  </thead>
  <tbody formArrayName="pfIndicators">
    <ng-container *ngFor="let com of pfIndicators?.controls; let i_pf_i = index"  [formGroupName]="i_pf_i">
      <tr *ngIf="currentItem[i_pf_i] as variable" [ngClass]="{'tr-disabled':!variable.meetingEnabled}" class="tr-{{i_pf_i % 2}}">
        <td class=" align-top">
          <span class="font-icon pointer"  title="{{variable?.show_critical? 'Retrair':'Expandir'}} pontos criticos e/ou ações"
            *ngIf="variable?.pf_ind_critical?.length > 0 || variable?.actions_not_delete?.length > 0" 
            (click)="variable['show_critical'] = variable['show_critical'] != null? !variable['show_critical']:true"> 
            keyboard_arrow_{{variable?.show_critical? 'up':'down'}}
          </span>
        </td>
        <td class="d-flex justify-content-start">
          <div>
            <input type="checkbox" class="mt-1 me-2" [checked]="variable?.checkeds" formControlName="checkeds" (change)="onCheckStatus(com)"/>
          </div>
          <span>
            <a [href]="generateLink(variable)" target="_blank">{{variable.title}} </a>
            <br/>
            <span *ngIf="variable?.pf_ind_manager_main?.tb_pss_pessoa?.str_nome" class="info-text">
              <div class="d-flex">
                <span class="pt-1 icon-person font-icon icon-fill text-dark" alt="Exibir detalhes do usuário" title="Exibir detalhes do usuário"
                  (click)="variable.show_resp = variable['show_resp'] != null? !variable['show_resp']:true">
                  person
                </span>
                <div class="responsavel">
                  <div class="tag2 strategic" *ngIf="variable.level_mon_id == 1">ESTRATÉGICO</div>
                  <div class="tag2 irfe" *ngIf="variable.irfe_enabled_id == 1">IRFE</div>
                  <div class="tag2 ircp" *ngIf="variable.ircp_enabled_id == 1">IRCP</div>
                  <div class="tag2 plano_rio_grande" *ngIf="variable.plano_rio_grande == 1">PLANO RIO GRANDE</div>
                </div>
              </div>
              
              <span class="info-text" *ngIf="variable.show_resp">
                Resp.: {{variable?.pf_ind_manager_main?.tb_pss_pessoa?.str_nome}}
                <br/>
                E-mail.: {{variable?.pf_ind_manager_main?.tb_pss_pessoa?.str_email_responsavel_projeto}}
                <br/>
                Telefone.: ({{variable?.pf_ind_manager_main?.tb_pss_pessoa?.num_ddd_1}}) {{variable?.pf_ind_manager_main?.tb_pss_pessoa?.num_telefone_1}}
              </span>
            </span>
          </span>
        </td>  
        <td>{{variable.code}} <span *ngIf="variable?.group_sum_root" class="info-text"><br/>(soma)</span></td>
        <td class="text-center">
          <div class="dot dot-arrow dot-arrow-single-{{variable?.polarity? 1:3}}" title="{{polar[variable?.polarity? '1':'3']}}"></div>
        </td>  
        <td>{{variable.unit_id}}
          <span class="info-text" *ngIf="variable?.accum != null && variable?.accum_table != null ">
            <br/>Acumulado
            <span class="info-text" *ngIf="variable?.accum_table">
              <br/>(visão composta)
            </span>
          </span>
          <span class="info-text" *ngIf="variable?.accum == null || variable?.accum_table == null">
            <br/>Não Acumulado
          </span>
        </td>

        <td class="text-center" *ngIf="variable?.showYearGoal">{{(variable?.year_goal | number:'1.0-2') ?? 'NI'}}</td>
        <td class="text-center">{{(variable?.current_goal | number:'1.0-2') ?? 'NI'}}</td>
        <td class="text-center">{{(variable?.current_done | number:'1.0-2') ?? 'NI'}}</td>
        <td class="text-center">{{getCurrentMonth(variable)}}</td>
        <td class="text-center">
          <div class="dot dot-{{variable?.current_table_status ?? 0}}"  title="{{status[variable?.current_table_status ?? 0]}}"></div>
        </td>
        <td class="text-center">
          <div class="dot dot-arrow dot-arrow-{{variable?.pf_ind_analysis_last?.ind_analysis_stat_id ?? 0}}" 
            title="{{analysis[variable?.pf_ind_analysis_last?.ind_analysis_stat_id ?? 0]}}"></div>
        </td>
        <!--<td class="text-center">{{variable?.pf_ind_analysis_last?.ctr_dth_atu | date: 'dd/MM/YYYY H:mm:s'}}</td>-->
        <td class="text-danger">{{variable?.pf_ind_critical?.length ?? 0}}</td>
        <td>
          <button type="button" class=" btn-font-icon " 
            *ngIf="(variable?.pf_ind_analysis_last?.description || variable?.goal || variable?.total_pa)  && expand == true" 
            (click)="variable['show_description'] = variable['show_description'] != null? !variable['show_description']:true"
            alt="Expandir/retrair informações extras" title="{{variable?.show_description?'Retrair':'Expandir'}} informações extras" >
            <img src="assets/images/svgs/Monitoring{{variable?.show_description?'':'-gray'}}.svg"placement="bottom">
          </button>
        </td>
      </tr>
      <ng-container *ngIf="currentItem[i_pf_i]['show_description'] == true && currentItem[i_pf_i] as variable" >
        <tr  class="tr-{{i_pf_i % 2}} b-bottom body-indicator">
          <td colspan="13">
            <div *ngIf="variable?.pf_ind_analysis_last?.description"   class="break-word td-description column-2">
              <b>Análise: </b>
              {{variable?.pf_ind_analysis_last?.description}}
              <br><b>Atualização: </b>
              {{variable?.pf_ind_analysis_last?.ctr_dth_atu | date: 'dd/MM/YYYY'}}
            </div>
            <div *ngIf="variable?.goal" class="break-word td-description">
              <b>Início: </b>{{variable.year_start}}
              <b>.  Término: </b>{{variable.year_end}}
              <b>.  Valor Total: </b>{{variable.goal | number:'1.0-2'}}
            </div>
            <div *ngIf="variable?.id " class="break-word td-description" >
              <div class="d-flex justify-content-center"  *ngIf="getGraph(variable) as graphData">
                <canvas baseChart class="chart" [data]="graphData?.chartData" [options]="graphData?.chartOptions" [type]="graphData?.chartType"></canvas>
              </div>
            </div>
          </td>
        </tr>
      </ng-container>
      <ng-container *ngIf="currentItem[i_pf_i]['show_critical'] == true && currentItem[i_pf_i] as variable">
        <tr *ngIf="variable?.pf_ind_critical?.length > 0" id="criticals" class="tr-{{i_pf_i % 2}}">
          <td colspan="13"  class="break-word td-description">
            <app-itens-check-critical *ngIf="variable?.pf_ind_critical as criticals"
              [parentFormGroup]="com"
              (checkStatus)="checkStatus"
              [currentItem]="criticals">
            </app-itens-check-critical>
          </td>
        </tr>
        <tr *ngIf="variable?.actions_not_delete?.length > 0" id="total_pa" class="tr-{{i_pf_i % 2}}">
          <td colspan="13"  class="break-word td-description">
            <app-itens-ind-action *ngIf="variable?.pf_ind_action_not_deleted as actions"
              [parentFormGroup]="com" class="action"
              [currentItem]="actions" formName="actions">
            </app-itens-ind-action>
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
</table>